
<template>
  <v-card class="my-2 py-2">

    <v-list-item desne>
      <v-list-item-avatar size="48" v-if="((applicants||{})[transaction.profileId]||{}).avatar">
        <v-img :src="((applicants||{})[transaction.profileId]||{}).avatar"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="body-1 font-weight-bold">
          {{transaction.jobTitle}}
        </v-list-item-title>
        <v-list-item-subtitle class="subtitle font-weight-bold">
          {{ $language.jobDetails['Recipient'] }}: {{transaction.recipientName}}
        </v-list-item-subtitle>
        <v-list-item-subtitle class="subtitle font-weight-bold">
          {{ $language.jobDetails['Date'] }}: {{transaction.paymentDate|formatShortDate}} <span class="caption">({{transaction.paymentDate|formatDateTime}})</span>
        </v-list-item-subtitle>
        <v-list-item-subtitle class="subtitle font-weight-bold">
          {{ $language.jobDetails['Status'] }}: {{transaction.status|formatStatus}} {{transaction.paymentAmount}}
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-icon @click="show=!show">{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-list-item-action>
    </v-list-item>
    <v-divider v-if="show"></v-divider>
    <v-expand-transition>
      <div v-show="show">
        <v-list-item>

          <v-list-item-content>
            <v-row>
              <v-col cols="12">
                <span>TRX ID: </span><span class=" font-weight-bold">{{transaction.txId}}</span>

              </v-col>
            </v-row>

          </v-list-item-content>
        </v-list-item>

      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'
export default {
  props: ['transaction', 'avatar', 'applicants'],
  data () {
    return {
      sub: '',
      show: false
    }
  },

  computed: {
    ...mapState(['userProfile', 'currentUser'])

  },
  methods: {},
  filters: {
    acceptedApplicants (val) {
      return Object.keys(val).reduce(function (acc, key) {
        if (val[key] === 'Applied') {
          return acc + 1
        }
        return acc
      }, 0)
    },
    formatImgURL (val) {
      return '@/assets/Agriculture.svg'
    },

    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      return moment(date).fromNow()
    },
    trimLength (val) {
      return `${val.substring(0, 8)}...`
    },
    formatStatus (val) {
      if (!val) {
        return '-'
      }
      switch (val) {
        case 'SUCCESS':
          return 'Paid'

        default:
          break
      }
    }

  }
}
</script>
